import { render, staticRenderFns } from "./TeamMemberSelector.vue?vue&type=template&id=b96f5376&"
import script from "./TeamMemberSelector.vue?vue&type=script&lang=ts&"
export * from "./TeamMemberSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMemberSelector.vue?vue&type=style&index=0&id=b96f5376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports